import type { RichMenuLayout } from '@foundation/shared';
import { RICH_MENU_WIDTH, fitLabel, richMenuBounds, setLabelFont } from '@foundation/shared';

/**
 * วาดรูป rich menu
 *
 * แยกออกมาจากหน้าเว็บเพื่อให้เครื่องมือฝั่ง Node (สคริปต์สร้างเมนูอัตโนมัติ)
 * เรียกโค้ดตัวเดียวกันได้ — ถ้าต่างคนต่างวาด รูปกับพื้นที่กดจะเลื่อนกันเมื่อไรก็ได้
 * โดยที่ทุกอย่าง "ดูปกติ"
 */
const GREEN = '#1f6b4a';
const GREEN_DARK = '#16513a';

/**
 * วาดรูปเมนูลงบน canvas
 *
 * วาดที่เบราว์เซอร์เพราะรันไทม์ Workers ไม่มีฟอนต์ให้วาดข้อความไทย
 * และผลพลอยได้คือผู้ดูแลเห็นตัวอย่างจริงก่อนกดสร้าง ไม่ใช่กดแล้วไปลุ้นในแอป LINE
 *
 * ใช้ค่าพิกัดจาก richMenuBounds ตัวเดียวกับที่ฝั่ง Worker ใช้สร้างพื้นที่กด
 * ถ้าแยกกันคำนวณ ปุ่มที่เห็นกับปุ่มที่กดได้จะเลื่อนไม่ตรงกัน
 */
export function drawMenu(
  canvas: HTMLCanvasElement,
  layout: RichMenuLayout,
  orgName: string,
  logo: HTMLImageElement | null,
): void {
  canvas.width = RICH_MENU_WIDTH;
  canvas.height = layout.height;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  layout.buttons.forEach((btn, i) => {
    const b = richMenuBounds(layout, i);
    const alt = (i + Math.floor(i / layout.columns)) % 2 === 0;

    ctx.fillStyle = alt ? '#ffffff' : '#f2f7f4';
    ctx.fillRect(b.x, b.y, b.width, b.height);

    ctx.strokeStyle = '#dbe5df';
    ctx.lineWidth = 4;
    ctx.strokeRect(b.x + 2, b.y + 2, b.width - 4, b.height - 4);

    const cx = b.x + b.width / 2;
    const single = layout.buttons.length === 1;

    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    // ปุ่มเดียวเต็มแถบ → วางไอคอนซ้ายข้อความ อ่านง่ายกว่าซ้อนกัน
    if (single) {
      ctx.font = '200px system-ui, sans-serif';
      ctx.fillText(btn.icon, cx - 420, b.y + b.height / 2);
      ctx.fillStyle = GREEN_DARK;
      ctx.font = 'bold 130px "IBM Plex Sans Thai", "Sarabun", system-ui, sans-serif';
      ctx.fillText(btn.label, cx + 120, b.y + b.height / 2);
      return;
    }

    ctx.font = '190px system-ui, sans-serif';
    ctx.fillText(btn.icon, cx, b.y + b.height * 0.38);

    ctx.fillStyle = GREEN_DARK;

    const maxWidth = b.width - 80;
    const { lines, fontSize } = fitLabel(ctx, btn.label, maxWidth);
    const lineHeight = Math.round(fontSize * 1.18);

    setLabelFont(ctx, fontSize);
    const startY = b.y + b.height * 0.72 - ((lines.length - 1) * lineHeight) / 2;
    lines.forEach((l, li) => ctx.fillText(l, cx, startY + li * lineHeight));
  });

  // แถบชื่อมูลนิธิด้านบน ช่วยให้เมนูดูเป็นของมูลนิธิจริง ไม่ใช่ปุ่มลอย ๆ
  ctx.fillStyle = GREEN;
  ctx.fillRect(0, 0, canvas.width, 8);

  if (logo) {
    const h = 110;
    const w = (logo.width / logo.height) * h;
    ctx.drawImage(logo, 60, 46, w, h);
  }
  if (orgName) {
    ctx.fillStyle = GREEN;
    ctx.textAlign = 'right';
    ctx.textBaseline = 'top';
    ctx.font = 'bold 62px "IBM Plex Sans Thai", "Sarabun", system-ui, sans-serif';
    ctx.fillText(orgName, canvas.width - 60, 56);
  }
}
